import React from 'react';
import { Tabs } from 'antd';
import { useTranslation } from 'react-i18next';
import { EDashboardTab } from './types';

interface DashboardTabsProps {
  activeTab: string;
  setActiveTab: (key: EDashboardTab) => void;
}

const DashboardTabs: React.FC<DashboardTabsProps> = ({
  activeTab,
  setActiveTab,
}) => {
  const { t } = useTranslation();
  const dashboardTabs = [
    {
      key: EDashboardTab.UW,
      label: (
        <span className="flex items-center gap-2">
          {t('dashboard.underwriterDashboard')}
        </span>
      ),
    },
    {
      key: EDashboardTab.FINANCE,
      label: (
        <span className="flex items-center gap-2">
          {t('dashboard.financeDashboard')}
        </span>
      ),
    },
    {
      key: EDashboardTab.CLAIM,
      label: (
        <span className="flex items-center gap-2">
          {t('dashboard.claimDashboard')}
        </span>
      ),
    },
  ];

  return (
    <div className="bg-[#E3F2FB] rounded-xl w-fit mb-9">
      <Tabs
        activeKey={activeTab}
        onChange={(key) => setActiveTab(key as EDashboardTab)}
        items={dashboardTabs}
        className="custom-tabs uw-custom-tabs ant-tabs-tab"
        tabBarGutter={8}
        tabBarStyle={{ margin: 0 }}
      />
    </div>
  );
};

export default DashboardTabs;
